module.exports = __webpack_public_path__ + "media/images/HBM-6477fba7f0f3d2427104355288d456bb.png";